import {
	listTransaksiEpayment,
	listTopupEpayment,
	listPaketEpaymentOwner,
	infoTopupEpayment,
	detailTopupEpayment,
	pagination,
	searchTopup
} from "./state"

const mutations = {
	setListTransaksiEpayment: (state, res) => {
		if (state.listTransaksiEpayment.data !== undefined) {
			state.listTransaksiEpayment.data.list_transaksi_epayment = [
				...state.listTransaksiEpayment.data.list_transaksi_epayment, ...res.data.list_transaksi_epayment
			];
		} else {
			state.listTransaksiEpayment = res
		}
	},
	setListTopupEpayment: (state, res) => {
		if (state.listTopupEpayment.data !== undefined) {
			state.listTopupEpayment.data = [
				...state.listTopupEpayment.data, ...res.data
			]
		} else {
			state.listTopupEpayment = res
		}
	},
	setListPaketEpaymentOwner: (state, res) => {
		state.listPaketEpaymentOwner = res
	},
	setInfoTopUpEpayment: (state, res) => {
		state.infoTopupEpayment = res
	},
	setDetailTopupEpayment: (state, res) => {
		state.detailTopupEpayment = res
	},
	resetListTransaksiEpayment: (state) => {
		state.listTransaksiEpayment = listTransaksiEpayment()
	},
	resetListTopupEpayment: (state) => {
		state.listTopupEpayment = listTopupEpayment()
	},
	resetListPaketEpaymentOwner: (state) => {
		state.listPaketEpaymentOwner = listPaketEpaymentOwner()
	},
	resetInfoTopupEpayment: (state) => {
		state.infoTopupEpayment = infoTopupEpayment()
	},
	resetDetailTopupEpayment: (state) => {
		state.detailTopupEpayment = detailTopupEpayment()
	},

	// pagination
	setNextPagination: (state, payload) => {
		state.pagination.length = payload.data.length
		state.pagination.pageNumber++
		state.pagination.offset = state.pagination.pageNumber * state.pagination.limit
	},
	resetPagination: (state, e) => {
		state.pagination = pagination()
	},

	// search
	setSearchTopup: (state, key) => {
		state.searchTopup.key = key
	},
	setIsSearchTopup: (state, bool) => {
		state.isSearchTopup = bool
	},
	resetSearchTopup: (state) => {
		state.searchTopup = searchTopup()
	},

	setScrollPosition: (state, positionY) => {
		state.scrollPosition = positionY - 100
	}
}

export default mutations